// extracted by mini-css-extract-plugin
export default {"formSelect":"SelectWithLabel_formSelect__uVjE7"};